import { Box, Typography } from "@mui/material";

import { CustomRating } from "@/components/UI-Kit/CustomRating";
import { calculateAverageRating } from "@/utils/calculateAverageRating";

interface IProps {
  title: string;
  reviews?: Review[]; //Will be added in the next version
}

const TitleRating: React.FC<IProps> = ({ title, reviews }) => {
  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "column-reverse" }}
      gap={1}
      mb={1}
    >
      <Typography variant="h1" component="h3" color="text.primary">
        {title}
      </Typography>

      {reviews && (
        <Box display="flex" gap={{ xs: 1, md: 2 }} alignItems="center">
          <CustomRating
            value={calculateAverageRating(reviews)}
            readOnly
            size="small"
          />
          <Typography variant="body1" color="text.secondary" fontWeight={600}>
            ({reviews.length} customer reviews)
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TitleRating;
